// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { SearchNotificationQueryArgs } from "./types/rtkQueryTypes";
import { Email, NotificationDocument } from "./types/search.service.types";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedNotificationApi = createApi({
    reducerPath: "cclTokenedNotificationApi",
    tagTypes: ["Notifications"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCclNotifications: builder.mutation<
            NotificationDocument[],
            Partial<SearchNotificationQueryArgs>
        >({
            query: (args) => ({
                url: `ccl-access2/Notifications/search`,
                method: "POST",
                body: args,
            }),
        }),
        getCclNotificationsByRecipient: builder.mutation<NotificationDocument[], string>({
            query: (email: string) => ({
                url: `ccl-access2/Notifications/search_by_email/${encodeURIComponent(email)}`,
                method: "POST",
            }),
        }),
        resendNotification: builder.mutation<string, string>({
            query: (resentNotificationId: string) => ({
                url: `ccl-access2/Notifications/resent/${resentNotificationId}`,
                method: "POST",
            }),
        }),
        getCclNotification: builder.query<Email, string>({
            query: (notificationId: string) => `ccl-access2/Notifications/${notificationId}`,
        }),
        sendNotificationLowers: builder.mutation<string, string>({
            query: (notificationId: string) => ({
                url: `ccl-access2/Notifications/send_notification_lowers/${notificationId}`,
                method: "POST",
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetCclNotificationsMutation,
    useGetCclNotificationsByRecipientMutation,
    useGetCclNotificationQuery,
    useResendNotificationMutation,
    useSendNotificationLowersMutation,
} = cclTokenedNotificationApi;
